<template>
  <QuestionnaireForm />
</template>

<script>
import QuestionnaireForm from "@/components/questionnaire/QuestionnaireForm.vue";

export default {
  name: "Questionnaire",
  components: { QuestionnaireForm },
};
</script>
